import React from 'react';

import { Text } from 'apps/auth/components/common/Text/Text';

import PanelForCard from './PanelForCard';
import { GaCardsContainer, GaCardsItem } from '../styles';

const isCardPlasticPendingActivation = (card = {}) => card.plastic && card.pendingActivation;

const PanelForCardList = ({ cards, orderedCardTitle }) => {
    const indexPendingActivation = cards.findIndex(isCardPlasticPendingActivation);
    const result = indexPendingActivation !== -1 ? cards.filter((card, index) => index !== indexPendingActivation) : cards;

    return (
        <>
            <GaCardsContainer>
                {result.map((card) => (
                    <GaCardsItem key={card?.id}>
                        <PanelForCard card={card} />
                    </GaCardsItem>
                ))}
            </GaCardsContainer>
            {indexPendingActivation !== -1 ? (
                <>
                    <Text variant="div" size="subheader" color="secondary" indent="adaptive-16-24">
                        {orderedCardTitle}
                    </Text>
                    <GaCardsContainer>
                        <GaCardsItem>
                            <PanelForCard card={cards[indexPendingActivation]} />
                        </GaCardsItem>
                    </GaCardsContainer>
                </>
            ) : null}
        </>
    );
};
export default PanelForCardList;
